<script>
import BaseLineItems from './../../TableList/LineItems.vue'
import LineItem from './LineItem.vue'
export default {
  extends: BaseLineItems,
  components: {
    LineItem
  },
  mounted() {
    this.$emitter.on('action.order.duplicate-line-item', this.actionDuplicateLineItem)
  },
  unmounted() {
    this.$emitter.off('action.order.duplicate-line-item', this.actionDuplicateLineItem)
  },
  computed: {
    data() {
      return this.config?.data
    },
    editable() {
      return this.config?.editable || {}
    },
    lineItemActions() {
      return [
        {
          type: 'action',
          id: 'order.duplicate-line-item',
          label: 'Duplicate'
        }
      ]
    },
    lineItems() {
      let actions = this.editable?.order ? (this.lineItemActions ?? []) : []
      return this.modelValue.map((lineItem, key) => {
        if (_.isUndefined(lineItem.new_actions)) {
          return Object.assign(lineItem, {
            index: key,
            actions: (lineItem.actions || []).concat(actions),
            new_actions: 1
          })
        } else {
          return Object.assign(lineItem, {
            index: key
          })
        }
      })
    }
  },
  methods: {
    actionDuplicateLineItem(e) {
      if (e.item?.identify) {
        let lineItems = Object.values(this.lineItems)
        lineItems.push(
          Object.assign(_.cloneDeep(e.item), {
            index: lineItems.length
          })
        )
        this.$emit('update:modelValue', lineItems)
      }
      return false
    }
  },
  props: {
    modelValue: {
      type: Array,
      default() {
        return []
      }
    },
    config: Object
  }
}
</script>
